import { notification } from 'antd';

// check response of api


export const checkResponse = (response: any) => {


    if (response?.status === 200 || response?.status === 201) {
        notification["success"]({
            message: "SUCCESS",
            description: "SUCCESSFULLY CREATED",
        })
    }
    else {
        notification["error"]({
            message: "Error",
            placement: 'bottomRight',
            description: response?.message ? response.message : "Something went wrong"
        })
    }
}

export const imageUrl = (type: string, catId: any) => {
    return `${process.env.REACT_APP_IMAGES_URL}products/${type}/${catId}/promos/images/rel.jpg?v=${Date.now()}`
}
export const musicUrl = (type: string, catId: any, soundClipFile: string) => {
    return `${process.env.REACT_APP_IMAGES_URL}products/${type}/${catId}/promos/${soundClipFile}`
}
export const DownloadAsset = (type: string, catId: any) => {

    return `${process.env.REACT_APP_IMAGES_URL}products/${type}/${catId}/promos/download.zip?v=${Date.now()}`
}
